import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import VueApollo from "vue-apollo";

const httpLinkProgram = new HttpLink({
  uri: process.env.VUE_APP_PROGRAMS_URL + "/graphql",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/json"
  }
});

const httpLinkClasses = new HttpLink({
  uri: process.env.VUE_APP_CLASSES_URL + "/graphql",
  headers: {
    Authorization: "Bearer " + process.env.VUE_APP_CLASSES_GRAPHQL_TOKEN
  }
});

const cache = new InMemoryCache();

// Create the apollo client
const apolloPrograms = new ApolloClient({
  link: httpLinkProgram,
  cache
});

const apolloClasses = new ApolloClient({
  link: httpLinkClasses,
  cache
});

export default new VueApollo({
  clients: {
    apolloPrograms,
    apolloClasses
  },
  defaultClient: apolloPrograms
});
